$(document).ready(function () {

    $.ajaxSetup({
        headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    AOS.init({
        //once: true,
        
    });

    initMobileMenu();
    initVenobox();

});

document.addEventListener('lazyloaded', function (e) {
    imgToBG($(".bg-img"), ".img-bg");
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

$(window).on('load scroll resize', function () {
    var hh = $('header').innerHeight();
    //$('.header-offset').css({'min-height': 'calc(100vh - '+ hh +'px)'});
    //$('.banner').css({ 'min-height': 'calc(100vh - ' + hh + 'px)' });
    $('.banner-text').css({ 'padding-top': hh }); //.header-offset.inner
    reSizeCaptcha();
})

window.captchaCallback = function(response) {
  $(".g-recaptcha").val(response);
};

window.reSizeCaptcha = function () {
    if ($(".g-recaptcha").parent().length) {
        var width = $(".g-recaptcha")
            .parent()
            .width();
        if (width < 330) {
            var scale = (width) / 330;

            $('.g-recaptcha').css("transform", "scale(" + scale + ")");
            $('.g-recaptcha').css("-webkit-transform", "scale(" + scale + ")");
        } else {
            $('.g-recaptcha').css("transform", "unset");
            $('.g-recaptcha').css("-webkit-transform", "unset");
        }
    }
}

$(window).on('scroll', function () {

    var header = $('header');
    var sticky = /* $('.banner').innerHeight() -  */header.innerHeight();

    stickyHeader(header, sticky);

});

function initMobileMenu() {
    if ($("#mobile-menu").length > 0) {
        var menu = new MmenuLight($("#mobile-menu").get(0));

        /*mmenu.create("(max-width: 1200px)");
    
         mmenu.init("current");*/
        var navigator = menu.navigation({
            // selectedClass: 'Selected',
            // slidingSubmenus: true,
            //theme: 'light',
            title: 'Menu'
        });

        var drawer = menu.offcanvas({
            position: 'left'
        });

        $('a[href="#mobile-menu"]').on("click", function (ev) {
            $('#mobile-menu').css("display", "block");
            drawer.open();

            ev.preventDefault();
            ev.stopPropagation();
        });
    }
}

function initVenobox() {
    $(".venobox").venobox({
        titlePosition: "bottom"
    });
}

function stickyHeader(header, sticky) {
    if ($(window).scrollTop() > sticky) {
        header.addClass('sticky');
    } else {
        header.removeClass('sticky');
    }
}

function imgToBG(bgClass, imageClass) {
    if (bgClass.length > 0) {
        bgClass.each(function () {
            var img = $(this).find(imageClass).eq(0);
            $(this).attr('data-bg', img.attr("src"));
            img.hide();
        });
    }
}

